<template>
  <div class="variantLabel fvlw">
    <span
      class="labelItem"
      :class="{ active: hasActive(item), disable: item.disable }"
      @click.stop="clickLabel({ ...item, pid, pName })"
      v-for="(item, index) in labelData"
      :key="index + '_' + item.code"
    >
      {{ item?.lable }}
    </span>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { getSession } from '@/util'

export default {
  name: 'variantLabel',
  props: {
    datas: {
      default: () => [],
      type: Array
    },
    pid: {
      default: () => '',
      type: String
    },
    pName: {
      default: () => '',
      type: String
    }
  },
  setup(props) {
    let store = useStore()
    let { datas, pid, pName } = toRefs(props)
    const state = reactive({
      datas,
      pid,
      pName
    })
    const labelData = computed(() => state.datas)
    const selectShopVariantItem = computed(() => store.state.selectShopVariantItem || {})
    const clickLabel = data => {
      // console.log('clickLabel', data, selectShopVariantItem.value)
      if (data.disable || getSession('ewScanFromOTR')) {
        return
      }
      let ShopVariant = { ...selectShopVariantItem.value }
      if (ShopVariant[state.pid] && ShopVariant[state.pid]['code'] === data.code) {
        ShopVariant[state.pid] = ''
      } else {
        ShopVariant = { ...ShopVariant, [state.pid]: data }
      }
      store.commit('SETSELECTSHOPVARIANTITEM', { ...ShopVariant })
    }
    const hasActive = item => {
      // console.log('hasActive----', selectShopVariantItem.value?.[state.pid]?.id, item.id)
      return selectShopVariantItem.value?.[state.pid]?.code === item.code
    }
    onMounted(async () => {})
    return {
      ...toRefs(state),
      labelData,
      selectShopVariantItem,
      hasActive,
      clickLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.menuLabel {
  background: #fff;
}
.labelItem {
  margin: 4px 5px;
  padding: 4px 16px;
  background: #eee;
  border: 1px solid transparent;
  border-radius: 4px;
  box-sizing: border-box;
}
.active {
  border: 1px solid #3088c5;
  color: #3088c5;
  background: #fff;
}
.disable {
  border: 1px solid #eee;
  color: #999;
  background: #eee;
  text-decoration: line-through;
}
</style>
